var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("¡Lo sentimos!")]),_c('h3',[_vm._v("No encontramos la página solicitada")]),_c('v-btn',{staticClass:"accent",attrs:{"to":"dashboard/manage_pages"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("home")]),_vm._v(" Regresar al inicio ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }